import { Link, useLocation } from "react-router-dom";
import { Home, Search, ShoppingCart, User, Store, Heart, MessageCircle } from "lucide-react";
import { useCart } from "../contexts/CartContext";
import { useAuth } from "../contexts/AuthContext";
import { useState, useEffect } from "react";

function useFavCount() {
  const [count, setCount] = useState(0);
  useEffect(() => {
    const update = () => {
      try { setCount(JSON.parse(localStorage.getItem("jkl_favorites") || "[]").length); } catch { setCount(0); }
    };
    update();
    window.addEventListener("storage", update);
    return () => window.removeEventListener("storage", update);
  }, []);
  return count;
}

export default function BottomNav() {
  const { cartCount } = useCart();
  const { user } = useAuth();
  const { pathname } = useLocation();
  const favCount = useFavCount();

  const guestItems = [
    { to: "/", icon: Home, label: "Accueil" },
    { to: "/catalogue", icon: Search, label: "Recherche" },
    { to: "/panier", icon: ShoppingCart, label: "Panier", cartBadge: true },
    { to: "/favoris", icon: Heart, label: "Favoris", favBadge: true },
  ];

  const vendorItems = [
    { to: "/", icon: Home, label: "Accueil" },
    { to: "/catalogue", icon: Search, label: "Catalogue" },
    { to: "/messages", icon: MessageCircle, label: "Messages" },
    { to: "/dashboard/vendeur", icon: Store, label: "Boutique" },
  ];

  const items = user?.role === "vendor" ? vendorItems : guestItems;

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 flex md:hidden z-50 safe-area-bottom shadow-lg" data-testid="bottom-nav">
      {items.map(({ to, icon: Icon, label, cartBadge, favBadge }) => {
        const isActive = pathname === to || (to !== "/" && pathname.startsWith(to));
        return (
          <Link
            key={to}
            to={to}
            className={`flex-1 flex flex-col items-center justify-center py-2 gap-0.5 min-h-[56px] relative transition-colors ${
              isActive ? "text-[#16A34A]" : "text-gray-400"
            }`}
            data-testid={`bottom-nav-${label.toLowerCase().replace(/\s/g, "-")}`}
          >
            <div className="relative">
              <Icon size={20} />
              {cartBadge && cartCount > 0 && (
                <span className="absolute -top-1.5 -right-1.5 bg-[#F59E0B] text-white text-[9px] font-bold rounded-full w-3.5 h-3.5 flex items-center justify-center">
                  {cartCount > 9 ? "9+" : cartCount}
                </span>
              )}
              {favBadge && favCount > 0 && (
                <span className="absolute -top-1.5 -right-1.5 bg-red-500 text-white text-[9px] font-bold rounded-full w-3.5 h-3.5 flex items-center justify-center">
                  {favCount > 9 ? "9+" : favCount}
                </span>
              )}
            </div>
            <span className="text-[10px] font-semibold">{label}</span>
            {isActive && (
              <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-5 h-0.5 bg-[#16A34A] rounded-full" />
            )}
          </Link>
        );
      })}
    </nav>
  );
}
